<template>
    <b-list-group-item
        :active="active"
        :to="to"
        class="rkm-sidebar-group-item"
    >
        <rkm-icon
            v-if="icon"
            :icon="icon"
            class="rkm-sidebar-group-item-icon"
        />

        <div>
            {{ title }}
        </div>
    </b-list-group-item>
</template>

<script>
// Components.
import {BListGroupItem} from 'bootstrap-vue'

export default {
    components: {BListGroupItem},
    props: {
        active: {type: Boolean},
        icon: {type: [Array, Object, String]},
        subItem: {type: Boolean},
        title: {type: String},
        to: {type: [Object, String]},
    },
}
</script>

<style lang="scss" scoped>
$primary: #007bff;

.active {
    background: none !important;
    color: darken($primary, 10%) !important;
}
.rkm-sidebar-group-item {
    align-items: center;
    border: none;
    display: flex;
}
.rkm-sidebar-group-item-active {
    background: none !important;
    color: darken($primary, 10%) !important;
}
.rkm-sidebar-group-item:hover {
    background: none;
    color: darken($primary, 10%) !important;
}
.rkm-sidebar-group-item-icon {
    margin-right: 15px;
}
</style>